import { render, staticRenderFns } from "./TestFilesAndPhotos.vue?vue&type=template&id=a3580866&"
import script from "./TestFilesAndPhotos.vue?vue&type=script&lang=js&"
export * from "./TestFilesAndPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports